import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import CustomModal from "../customModal";
import { toggleSelectOptionsModal } from "../../store/slices/appGeneralSlice";

import './SelectOptionsModal.scss';

interface SelectOptionsModalProps {
    selectedValue?: CashBoxId;
    handleSelectOption: (val: CashBoxId) => void;
}

const SelectOptionsModal = (props: SelectOptionsModalProps) => {
    const {
        handleSelectOption,
        selectedValue,
    } = props;

    const dispatch = useDispatch();

    // const showModal = useSelector((state: RootState) => state.paymentManagement.showOpenPaymentsModal);
    const showModal = useSelector((state: RootState) => state.appGeneral.showSelectOptionsModal);
    const modalSelectTitle = useSelector((state: RootState) => state.appGeneral.modalSelectTitle);
    const modalSelectOptionsList = useSelector((state: RootState) => state.appGeneral.modalSelectOptionsList);

    const handleCloseModal = () => {
        dispatch(toggleSelectOptionsModal({
            showModal: false,
            selectTitle: "",
            selectOptions: []
        }));
    };

    const handleClickOnSelectOption = (optVal) => {
        if (typeof handleSelectOption === "function") {
            handleSelectOption(optVal);
        }
        handleCloseModal();
    };

    return (
        <CustomModal
            size="sm"
            // centered
            show={showModal}
            onHide={handleCloseModal}
            className="select-options-preview-modal"
        >
            <Modal.Body>
                <div className="select-title-bar">
                    <h4 className="select-title mb-0">
                        {modalSelectTitle}
                    </h4>
                </div>
                <ul className="options-list mb-2">
                    {modalSelectOptionsList?.length && modalSelectOptionsList.map((opt) => {
                        const {
                            label,
                            value,
                            // code
                        } = opt || {};

                        return (
                            <li
                                key={value}
                                className={`option-item ${selectedValue === value ? 'is-selected' : ''}`}
                                onClick={() => handleClickOnSelectOption(value)}
                            >
                                {label}
                            </li>
                        )
                    })}
                </ul>
            </Modal.Body>
        </CustomModal>
    )
}

export default SelectOptionsModal;

